import { render } from "./SalesPerBrand.vue?vue&type=template&id=278d24af"
import script from "./SalesPerBrand.vue?vue&type=script&lang=js"
export * from "./SalesPerBrand.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__